import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';

export default function useAnswerChange(questionId, formName) {
  const { watch, setValue } = useFormContext();
  const currentName = formName ?? `question-${questionId}`;
  const currentAnswer = watch(currentName);

  const getCurrentAnswerObject = useCallback(
    (answerId) =>
      currentAnswer?.find((answerObj) => answerObj.answerId === answerId),
    [currentAnswer]
  );

  const handleChangeRadio = useCallback(
    (answerObject, text, onChange) => {
      const {
        id: answerId,
        specialName,
        text: answerObjectText,
      } = answerObject;

      const newAnswer = {
        answerId,
        questionId,
        specialName,
      };

      if (answerObjectText) {
        newAnswer.text = answerObjectText;
      }

      if (text) {
        newAnswer.text = text;
      }

      if (onChange) {
        onChange([newAnswer]);
      } else {
        setValue(currentName, [newAnswer]);
      }
    },
    [currentName, questionId, setValue]
  );

  const handleChangeMultiple = useCallback(
    (answerObject, text, question, onChange) => {
      const selectedAnswerId = answerObject.id;
      const alreadyAnswered = currentAnswer?.find(
        (ansObj) => ansObj.answerId === selectedAnswerId
      );

      let updatedValues = [];

      if (currentAnswer) {
        updatedValues = [...currentAnswer];
      }

      if (alreadyAnswered) {
        updatedValues = currentAnswer.filter(
          (el) => el.answerId !== selectedAnswerId
        );
      }

      if (
        !alreadyAnswered ||
        (question?.type === 'multiple' && alreadyAnswered.text !== text)
      ) {
        const newAnswer = {
          answerId: selectedAnswerId,
          questionId,
          specialName: answerObject.specialName,
        };

        if (text) {
          newAnswer.text = text;
        } else if (answerObject.text) {
          newAnswer.text = answerObject.text;
        }

        updatedValues = [...updatedValues, newAnswer];
      }

      if (onChange) {
        onChange(updatedValues);
      } else {
        setValue(currentName, updatedValues);
      }
    },
    [currentAnswer, currentName, questionId, setValue]
  );

  return {
    currentName,
    getCurrentAnswerObject,
    handleChangeRadio,
    handleChangeMultiple,
  };
}
